import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Maestro_ConfiguracionComercializacionDetalle } from 'src/app/models/generic/Maestro_ConfiguracionComercializacionDetalle';
import { Maestro_ConfiguracionComercializacion } from 'src/app/models/generic/Maestro_ConfiguracionComercializacion';
import { MaestroConfiguracionComercializacionActualizacion } from 'src/app/models/generic/MaestroConfiguracionComercializacionActualizacion';
import { Maestros_ConfiguracionComercializacionService } from 'src/app/services/maestros_configuracioncomercializacion.service';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { Listas } from 'src/app/models/generic/Listas';

@Component({
  selector: 'maestros-configuracioncomercializacion-editar',
  templateUrl: './maestros-configuracioncomercializacion-editar.component.html',
  styleUrls: ['./maestros-configuracioncomercializacion-editar.component.scss']
})
export class MaestrosConfiguracionComercializacionEditarComponent implements OnInit{
  
  form: FormGroup;
  formConsulta: FormGroup;
  tituloForma: string = 'Configuración comercialización';
  tituloBoton: string = 'Guardar';
  mostrarCargando: boolean = false;
  codigoAccion: string = '';
  codigoAccionActualizacion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  detalleSeleccionadoDetalles: number;
  formDetalles: FormGroup;
  editarRegistroDetalles: boolean = false;
  @ViewChild('paginatordetalles') paginatorDetalles: MatPaginator;
  @ViewChild(MatSort) sortDetalles: MatSort;
  dataSourceDetalles: MatTableDataSource<Maestro_ConfiguracionComercializacionDetalle>;
  columnasEncabezadoDetalles: string[] = ['id', 'tipoConfiguracion', 'tipoParametro', 'parametroConfiguracion', 'acciones'];
  listaDatosDetalles: Maestro_ConfiguracionComercializacionDetalle[] = [];
  listaDatosDetallesFiltrada: Maestro_ConfiguracionComercializacionDetalle[] = [];
  listaDatosDetallesGuardar: Maestro_ConfiguracionComercializacionDetalle[] = [];
  listaDatosDetallesEliminar: Maestro_ConfiguracionComercializacionDetalle[] = [];
  parametrosPrincipal: Maestro_ConfiguracionComercializacion;
  tabItemSeleccionado: string = 'tabInformacion';
  listaCondicionParametroSiNo: Listas[] = [];
  listasTipoConfiguracion: Listas[] = [];
  listasTipoParametro: Listas[] = [];
  listaCondicionSiNo: Maestro_EstadoActualizar[] = [];
  listaParametrosPrograma: Listas[] = [];
  listaParametrosAliado: Listas[] = [];
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_ConfiguracionComercializacionService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public modal: MatDialog) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.listaCondicionParametroSiNo = [];
    this.listasTipoConfiguracion = [];
    this.listasTipoParametro = [];
    this.listaCondicionSiNo = [];
    this.listaParametrosPrograma = [];
    this.listaParametrosAliado = [];

    this.listaCondicionSiNo.push({ seleccionado: true, descripcion: 'Si' });
    this.listaCondicionSiNo.push({ seleccionado: false, descripcion: 'No' });
    this.listaCondicionParametroSiNo = this.itemListaActualizar(this.listaCondicionParametroSiNo, 'SI', 'Si');
    this.listaCondicionParametroSiNo = this.itemListaActualizar(this.listaCondicionParametroSiNo, 'NO', 'No');
    this.listasTipoConfiguracion = this.itemListaActualizar(this.listasTipoConfiguracion, 'ALIADO', 'Aliado');
    this.listasTipoConfiguracion = this.itemListaActualizar(this.listasTipoConfiguracion, 'PROGRAMA', 'Programa');
    this.listasTipoParametro = this.itemListaActualizar(this.listasTipoParametro, 'SI/NO', 'SI/NO');
    // parametros aliado
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'MANEJACARTERA', 'Maneja cartera');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'REGISTRAR', 'Registrar');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'CALCULOPRECIOEDAD', 'Calculo precio edad');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'RECAUDOWEB', 'Recaudo web');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'FILTRARPRODUCTOCANAL', 'Fitrar producto canal');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'CARGARPROSPECTOS', 'Cargar prospectos');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'FILTROFORMATOPROSPECTOS', 'Filtro formato prospectos');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'MANEJAPROGRAMAS', 'Maneja programas');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'EXPEDIENTES', 'Expendientes');
    this.listaParametrosAliado = this.itemListaActualizar(this.listaParametrosAliado, 'CAMBIOESTADO', 'Cambio estado');
    // parametros programa
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'REGISTRARBENEFICIARIO', 'Registrar beneficiario');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'BENEFICIARIOREQUERIDO', 'Beneficiario requerido');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'NOTIFICACIONSMS', 'Notificación SMS');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'NOTIFICACIONEMAIL', 'Notificación Email');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'REGISTRARESTADO', 'Registrar estado');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'MANEJAFECHANACIMIENTO', 'Manejo fecha nacimiento');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'MANEJADOMICILIO', 'Manejo domicilio');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'MANEJAOBSERVACIONES', 'Manejo observaciones');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'MANEJAFIRMAELECTRONICA', 'Manejo firma electrónica');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'OPERACIONESREEMBOLSO', 'Operaciones reembolso');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'SOLICITARTOMADOR', 'Solicitar tomador');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'DUPLICARTITULAR', 'Duplicar títular');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'ESTADODEPENDIENTEFECHA', 'Estado dependiente fecha');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'PERMITEEDITAR', 'Permite editar');
    this.listaParametrosPrograma = this.itemListaActualizar(this.listaParametrosPrograma, 'PROGRAMACIONPRECIOS', 'Programación precios');
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorDetalles);

    console.log('parametros', this.menuService.ParametrosAdicionales);
    if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);
      if (this.utilitariosService.VerificarContieneDatos(this.parametrosPrincipal)) {
        this.form.setValue(this.parametrosPrincipal);
      }
    }

    if (!this.utilitariosService.VerificarContieneDatos(this.parametrosPrincipal)) {
      this.parametrosPrincipal = new Maestro_ConfiguracionComercializacion();
    }
    
    this.tituloForma = 'Edición de configuración comercialización';
    this.tituloBoton = 'Guardar';

    this.ConsultarRegistrosDetalles();
  }
  itemListaActualizar(listas: Listas[], codigo: string, descripcion: string): Listas[] {
    let itemAgregar: Listas = new Listas();
    itemAgregar.codigo = codigo;
    itemAgregar.descripcion = descripcion;
    listas.push(itemAgregar);

    return listas;
  }
  tabSeleccionado(item: any) {
    console.log('tabSeleccionado', item);
    this.tabItemSeleccionado = item.tab.textLabel;
  }
  IniciarFormulario() {
    this.form = this.fb.group({
      'id': new FormControl(0),
      'codigo': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'activo': new FormControl(false),
    });

    this.formConsulta = this.fb.group({
      filtro: ['']
    });

    this.IniciarFormularioDetalles();
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosConfiguracionComercializacionComponent');
  }
  Guardar(codigoAccionActualizacion: string = '') {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this.codigoAccionActualizacion = codigoAccionActualizacion;
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      if (codigoAccionActualizacion !== '') {
        this.utilitariosService.MensajeToast('Es necesario que la pestaña de información tenga los datos validos para utilizar esta opción.');
      }
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      } else if (this.codigoAccion === 'eliminarDetalles') {
        this.EliminarRegistroDetalle();
      }
    }
  }
  ActualizarRegistro() {
    if (!this.mostrarCargando) {
      this.mostrarCargando = true;
    
      let parametrosActualizacion: MaestroConfiguracionComercializacionActualizacion = new MaestroConfiguracionComercializacionActualizacion();
      parametrosActualizacion.principal = new Maestro_ConfiguracionComercializacion();
      parametrosActualizacion.principal.id = this.form.get('id').value;
      parametrosActualizacion.principal.codigo = this.form.get('codigo').value;
      parametrosActualizacion.principal.descripcion = this.form.get('descripcion').value;
      parametrosActualizacion.principal.activo = this.form.get('activo').value;
      
      parametrosActualizacion.listaDetalles = this.listaDatosDetallesGuardar;
      parametrosActualizacion.listaDetallesEliminar = this.listaDatosDetallesEliminar;
  
      this.datosServices.Actualizar(parametrosActualizacion)
              .subscribe((resp: RespuestaGenerica) =>{
                this.mostrarCargando = false;
                if (!resp.procesoExitoso) {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                } else {
                  this.form.get('id')?.setValue(resp.id);
                  this.menuService.CambiarComponenteActivo('MaestrosConfiguracionComercializacionComponent');
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosDetalles() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        filtro: ['']
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      
      this.datosServices.ConsultarDetalles(parametrosConsulta.value)
                .subscribe((resp: Maestro_ConfiguracionComercializacionDetalle[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosDetalles = resp;
                  this.FiltrarRegistrosDetalles();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  //Detalles
  IniciarFormularioDetalles() {
    this.formDetalles = this.fb.group({
      'id': new FormControl(0),
      'idConfiguracion': new FormControl(0),
      'tipoConfiguracion': new FormControl('', [Validators.required, Validators.maxLength(20)]),
      'tipoParametro': new FormControl('', [Validators.required, Validators.maxLength(20)]),
      'parametroConfiguracion': new FormControl('', [Validators.required, Validators.maxLength(50)]),
      'valorConfiguracion': new FormControl('', [Validators.required]),
    });

    if (this.listasTipoConfiguracion.length === 1) {
      this.formDetalles.get('tipoConfiguracion').setValue(this.listasTipoConfiguracion[0].codigo);
    }
    if (this.listasTipoParametro.length === 1) {
      this.formDetalles.get('tipoParametro').setValue(this.listasTipoParametro[0].codigo);
    }
  }
  recargarListaDetalles() {
    this.dataSourceDetalles = new MatTableDataSource(this.listaDatosDetallesFiltrada);
    setTimeout(() => {
      this.dataSourceDetalles.paginator = this.paginatorDetalles;
      this.dataSourceDetalles.sort = this.sortDetalles;
    });
  }
  NuevoDetalle() {
    this.editarRegistroDetalles = true;
    this.IniciarFormularioDetalles();
    this.formDetalles.get('id').setValue((this.listaDatosDetalles.length + 1) * -1);
  }
  EditarDetalle(detalleEditar: Maestro_ConfiguracionComercializacionDetalle) {
    this.editarRegistroDetalles = true;
    this.formDetalles.setValue(detalleEditar);
  }
  EliminarDetalle(configuracionDetalle: Maestro_ConfiguracionComercializacionDetalle) {
    this.detalleSeleccionadoDetalles = configuracionDetalle.id;
    this.codigoAccion = 'eliminarDetalles';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarDetalle() {
    if (this.formDetalles.valid) {
      // validar si existe el registro
      if (this.listaDatosDetalles.filter(x => x.id !== this.formDetalles.get('id').value
                                          && x.tipoConfiguracion === this.formDetalles.get('tipoConfiguracion').value
                                          && x.parametroConfiguracion === this.formDetalles.get('parametroConfiguracion').value).length > 0) {
        this.utilitariosService.MensajeToast('Ya existe un registro con el mismo Tipo configuración y Parámetro');
        return;
      }
      
      this.editarRegistroDetalles = false;
      
      if (this.listaDatosDetalles.filter(x => x.id === this.formDetalles.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosDetalles.filter(x => x.id === this.formDetalles.get('id').value)[0];
        parametroActualizar.tipoConfiguracion = this.formDetalles.get('tipoConfiguracion').value;
        parametroActualizar.tipoParametro = this.formDetalles.get('tipoParametro').value;
        parametroActualizar.parametroConfiguracion = this.formDetalles.get('parametroConfiguracion').value;
        parametroActualizar.valorConfiguracion = this.formDetalles.get('valorConfiguracion').value;
      } else {
        this.listaDatosDetalles.push(this.formDetalles.value);
      }

      if (this.listaDatosDetallesGuardar.filter(x => x.id === this.formDetalles.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosDetallesGuardar.filter(x => x.id === this.formDetalles.get('id').value)[0];
        parametroActualizar.tipoConfiguracion = this.formDetalles.get('tipoConfiguracion').value;
        parametroActualizar.tipoParametro = this.formDetalles.get('tipoParametro').value;
        parametroActualizar.parametroConfiguracion = this.formDetalles.get('parametroConfiguracion').value;
        parametroActualizar.valorConfiguracion = this.formDetalles.get('valorConfiguracion').value;
      } else {
        this.listaDatosDetallesGuardar.push(this.formDetalles.value);
      }
      
      this.FiltrarRegistrosDetalles();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formDetalles);
    }
  }
  CancelarEditarDetalle() {
    this.editarRegistroDetalles = false;
  }
  EliminarRegistroDetalle() {
    if (this.detalleSeleccionadoDetalles > 0) {
      this.listaDatosDetallesEliminar.push(this.listaDatosDetalles.filter(x => x.id === this.detalleSeleccionadoDetalles)[0]);
    }
    let listaNueva: Maestro_ConfiguracionComercializacionDetalle[] = [];
    for (let index = 0; index < this.listaDatosDetalles.length; index++) {
      if (this.listaDatosDetalles[index].id !== this.detalleSeleccionadoDetalles) {
        listaNueva.push(this.listaDatosDetalles[index]);
      }
    }
    this.listaDatosDetalles = listaNueva;
    this.FiltrarRegistrosDetalles();
  }
  FiltrarRegistrosDetalles() {
    let filtrarTexto: string = this.formConsulta.get('filtro').value.toString();
    filtrarTexto = filtrarTexto.toLowerCase();
    this.listaDatosDetallesFiltrada = this.listaDatosDetalles.filter(x => 
      x.id.toString().includes(filtrarTexto)
      || x.tipoConfiguracion.toLowerCase().includes(filtrarTexto) 
      || x.tipoParametro.toLowerCase().includes(filtrarTexto)
      || x.parametroConfiguracion.toLowerCase().includes(filtrarTexto)
    );
    this.recargarListaDetalles();
  }
  MostrarBuscadorDetalleSINO(): boolean {
    return this.formDetalles.get('tipoParametro')?.value === 'SI/NO'; 
  }
  MostrarTipoConfiguracionPrograma(): boolean {
    return this.formDetalles.get('tipoConfiguracion')?.value === 'PROGRAMA';
  }
  //**************************************/
}
